import Navigation from "@/components/Navigation";
import HeroSection from "@/components/HeroSection";
import VerticalCardsSection from "@/components/VerticalCardsSection";
import HowItWorksSection from "@/components/HowItWorksSection";
import WhyFlexauraSection from "@/components/WhyFlexauraSection";
import PartnerLogos from "@/components/PartnerLogos";
import CTASection from "@/components/CTASection";
import Footer from "@/components/Footer";
import ComplianceNote from "@/components/ComplianceNote";
import StickyMobileCTA from "@/components/StickyMobileCTA";
import CookieConsent from "@/components/CookieConsent";
import AskFlexaura from "@/components/ai/AskFlexaura";
import TrustBadges from "@/components/TrustBadges";
import { suggestFinancePlans } from "@/lib/finance-plans";
import SEOHead from "@/components/SEOHead";

const Index = () => {
  const financeAmount = 50000;
  const financeOptions = suggestFinancePlans({
    vertical: "education",
    amountAED: financeAmount,
    context: { level: "primary", termCount: 3, enrolled: true }
  });

  return (
    <div className="min-h-screen bg-background">
      <SEOHead page="default" />
      <Navigation />
      <main>
        {/* 1. Hero */}
        <HeroSection />

        {/* 2. Vertical Cards */}
        <VerticalCardsSection />

        {/* 3. How It Works */}
        <HowItWorksSection />

        {/* 4. Why Flexaura */}
        <WhyFlexauraSection />

        {/* 5. Partner Logos */}
        <PartnerLogos />

        {/* 6. CTA */}
        <CTASection />
      </main>
      <ComplianceNote />
      <Footer />
      <StickyMobileCTA />
      <CookieConsent />
      <AskFlexaura 
        context={{ vertical: "education", amountAED: financeAmount }}
        plans={financeOptions}
      />
    </div>
  );
};

export default Index;
